const NetworkConstant = {
  //! End points for api url
  getQuestionByChapterId: "v1/api/chapter/get-questions-by-chapter-id",
  uploadTestResponse: "v1/api/chapter/upload-test-response",
  getTestResponseByUserIdAndChapterId: "v1/api/chapter/get-test-response-by-user-id-and-chapter-id",
};

export { NetworkConstant };
